export default "__VITE_ASSET__Dvp6_Pia__"